import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import { TMCZ_DOMAIN } from '@/shared/constants';

@Component
export default class Footer extends Vue {
  public getDomain(): string {
    return TMCZ_DOMAIN;
  }
}
